import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, SecurityContext, input } from '@angular/core';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { IconBigMediumPfeilRechts } from '@big-direkt/utils/icons';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardLinkComponent } from '../card-link/card-link.component';
import { CardComponent } from '../card/card.component';
import { UiCardImageModel } from './card-image.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-image-hl-text-link',
    templateUrl: './card-image.component.html',
    imports: [CardComponent, DatePipe, NgClass, Nl2brPipe, SanitizePipe, TranslocoDirective, UiPictureModule, CardLinkComponent],
})
export class CardImageComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    public readonly data = input.required<UiCardImageModel>();
    public readonly hideLink = input(false);
    public readonly imagePlacement = input<'left' | 'right' | 'top'>('top');
}
